import { __assign } from "tslib";
import React from 'react';
export var Element = function (p) { return React.createElement(List, __assign({}, p)); };
var Block = function (_a) {
    var attributes = _a.attributes, children = _a.children, element = _a.element;
    switch (element.type) {
        case 'heading-one':
            return React.createElement("h1", __assign({ style: getCSS(element) }, attributes), children);
        case 'heading-two':
            return React.createElement("h2", __assign({ style: getCSS(element) }, attributes), children);
        case 'heading-tre':
            return React.createElement("h3", __assign({ style: getCSS(element) }, attributes), children);
        case 'heading-for':
            return React.createElement("h4", __assign({ style: getCSS(element) }, attributes), children);
        default:
            return React.createElement("p", __assign({ style: getCSS(element) }, attributes), children);
    }
};
var List = function (p) {
    var attributes = p.attributes, children = p.children, element = p.element;
    return React.createElement(Block, { attributes: attributes, element: element }, children);
};
var getCSS = function (_a) {
    var align = _a.align, tabs = _a.tabs, type = _a.type, list = _a.list, children = _a.children;
    var font = getFontSize(type) / 10;
    var t2 = tabs * 2;
    var t = list === 'paragraph' ? t2 : t2 + font;
    var s = list === 'paragraph' ? {} : { display: 'list-item', listStyleType: list === 'bulleted-list' ? 'disc' : 'square' };
    var color = children[0] ? children[0].color : '#000';
    return __assign(__assign({ float: 'right', textAlign: align, padding: '0 0 0 0', fontSize: "".concat(font, "rem"), minHeight: "".concat(font, "rem"), width: "calc(100% - ".concat(t + 0.1, "rem)"), margin: '.05rem .05rem .05rem .05rem' }, s), { color: color });
};
var getFontSize = function (type) {
    if (type === 'heading-one')
        return 26;
    if (type === 'heading-two')
        return 22;
    if (type === 'heading-tre')
        return 18;
    if (type === 'heading-for')
        return 14;
    return 10;
};
//# sourceMappingURL=Element.js.map